import React, { useState } from 'react';
import api from '@/auth/api';
import { alertSuccess, alertError } from '@/components/Alert';


const AddAgencyForm = ({ onSuccess, agencyCategoryList, agencySubCategoryList }) => {
  const [formData, setFormData] = useState({
    agencyName: '',
    Category: '',
    SubCategory: '',
    agencyDetail: '',
    Collaboration_at: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const resp = await api.post("/redeem/panel/agency", formData);
      alertSuccess("Agency added successfully!");
  
      if (onSuccess) {
        onSuccess();
      }
  
      setFormData({
        agencyName: '',
        Category: '',
        SubCategory: '',
        agencyDetail: '',
        Collaboration_at: ''
      });
  
    } catch (error) {
      alertError(error?.response?.data?.errors || "Something went wrong.");
    }
  };
  

  const handleChange = ({ target: { name, value } }) =>
    setFormData(prev => ({ ...prev, [name]: value }));


  return (
    <form onSubmit={handleSubmit} className="max-w-sm mx-auto bg-white border p-3 rounded text-sm space-y-3">
      <div>
        <label className="block mb-1">Agency Name</label>
        <input type="text" name="agencyName" value={formData.agencyName} onChange={handleChange} required
          className="w-full border px-2 py-1 rounded" />
      </div>

      <div>
        <label className="block mb-1">Category</label>
        <select name="Category"  value={formData.Category} onChange={handleChange} required
          className="w-full border px-2 py-1 rounded">
          <option value="" disabled>Select</option>
          {agencyCategoryList.map(opt => (
            <option key={opt.id} value={opt.id}>{opt.title}</option>
          ))}
        </select>
      </div>

      <div>
        <label className="block mb-1">SubCategory</label>
        <select name="SubCategory" value={formData.SubCategory} onChange={handleChange} required
          className="w-full border px-2 py-1 rounded">
          <option value="" disabled>Select</option>
          {agencySubCategoryList.map(opt => (
            <option key={opt.id} value={opt.id}>{opt.title}</option>
          ))}
        </select>
      </div>

      <div>
        <label className="block mb-1">Agency Detail</label>
        <textarea name="agencyDetail" value={formData.agencyDetail} onChange={handleChange} rows={2} required
          className="w-full border px-2 py-1 rounded" />
      </div>

      <div>
        <label className="block mb-1">Collaboration Date</label>
        <input type="date" name="Collaboration_at" value={formData.Collaboration_at} onChange={handleChange} required
          className="w-full border px-2 py-1 rounded" />
      </div>

      <button type="submit" className="w-full bg-blue-600 text-white py-1 rounded hover:bg-blue-700">
        Submit
      </button>
    </form>
  );
};

export default AddAgencyForm;
